/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessStoryResponseAdminDto } from '../../models/success-story-response-admin-dto';

export interface AdminSuccessStoriesControllerListSuccessStoriesV1$Params {
}

export function adminSuccessStoriesControllerListSuccessStoriesV1(http: HttpClient, rootUrl: string, params?: AdminSuccessStoriesControllerListSuccessStoriesV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SuccessStoryResponseAdminDto>>> {
  const rb = new RequestBuilder(rootUrl, adminSuccessStoriesControllerListSuccessStoriesV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SuccessStoryResponseAdminDto>>;
    })
  );
}

adminSuccessStoriesControllerListSuccessStoriesV1.PATH = '/v1/admin/success-stories';
